// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getStorage } from 'firebase/storage';
import { getFirestore } from 'firebase/firestore';
import 'firebase/storage';

const API_KEY = process.env.REACT_APP_FIREBASE_API_KEY;
const firebaseConfig = {
    apiKey: API_KEY,
    authDomain: "zappar-habit-tracker.firebaseapp.com",
    projectId: "zappar-habit-tracker",
    storageBucket: "zappar-habit-tracker.appspot.com",
    messagingSenderId: "929432107818",
    appId: "1:929432107818:web:4734cded095f2e65c8bc53"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const storage = getStorage(app);
export const db = getFirestore(app);
export default app;